import React, { useMemo, useState } from 'react';
import { FiX } from 'react-icons/fi';
import { SOCIAL_PLAYOFF_ROUNDS } from '../../constants/config';
import { resolveImage } from '../../utilities/infographics';
import '../../styles/editModal.css';
import '../../styles/infographics.css';

// Сетка плей-офф. Перенос PlayoffChoose из приложения: раунды и слоты заданы
// жёстко, админ подставляет в каждый слот реальный матч. На сервер уходит
// та же структура [{name, data:[{name, id_front, ...матч}]}].
//props:
// open, onClose
// rounds — уже собранная сетка (activePlayoffMatches)
// onPick — (сетка) при сохранении
// onOpenMatchPicker — (callback) открыть выбор матча у родителя

const buildEmpty = () => SOCIAL_PLAYOFF_ROUNDS.map(round => ({
    name: round.name,
    data: round.slots.map((slot, index) => ({
        name: `Матч ${index + 1}`,
        id_front: slot,
    })),
}));

export default function PlayoffEditor({ open, onClose, rounds, onPick, onOpenMatchPicker }) {
    const [draft, setDraft] = useState(null);

    const current = useMemo(() => {
        if (draft) return draft;
        if (Array.isArray(rounds) && rounds.length) return rounds;
        return buildEmpty();
    }, [draft, rounds]);

    if (!open) return null;

    const assign = (frontId, match) => {
        setDraft(current.map(round => ({
            ...round,
            data: round.data.map(slot => (
                slot.id_front === frontId
                    ? { name: slot.name, id_front: frontId, front_id: frontId, ...match }
                    : slot
            )),
        })));
    };

    const clearSlot = (frontId) => {
        setDraft(current.map(round => ({
            ...round,
            data: round.data.map(slot => (
                slot.id_front === frontId
                    ? { name: slot.name, id_front: frontId }
                    : slot
            )),
        })));
    };

    const filled = current.reduce(
        (sum, round) => sum + round.data.filter(slot => slot.id).length, 0,
    );

    return (
        <div className="modalOverlay" onClick={onClose}>
            <div className="modalContent modalContentWide" onClick={(e) => e.stopPropagation()}>
                <div className="modalHeader">
                    <h2>Сетка плей-офф</h2>
                    <button className="modalClose" onClick={onClose}>×</button>
                </div>

                <div className="modalBody modalBodyScroll">
                    {current.map(round => (
                        <div className="igSlotSection" key={round.name}>
                            <h4 className="igSlotSectionTitle">{round.name}</h4>
                            {round.data.map(slot => (
                                <div className="igSlotRow" key={slot.id_front}>
                                    <span className="igSlotPosition">{slot.name}</span>
                                    <button
                                        type="button"
                                        className="igSlotPicker"
                                        onClick={() => onOpenMatchPicker(
                                            (match) => assign(slot.id_front, match),
                                        )}
                                    >
                                        {slot.id ? (
                                            <>
                                                {resolveImage(slot.home_team_image) ? (
                                                    <img src={resolveImage(slot.home_team_image)} alt="" />
                                                ) : null}
                                                <span className="igSlotName">
                                                    {`${slot.home_team_name || '—'} — ${slot.guest_team_name || '—'}`}
                                                </span>
                                            </>
                                        ) : (
                                            <span className="igPickerPlaceholder">Выбрать матч</span>
                                        )}
                                    </button>
                                    {slot.id ? (
                                        <button
                                            type="button"
                                            className="igSlotIconBtn"
                                            title="Очистить"
                                            onClick={() => clearSlot(slot.id_front)}
                                        >
                                            <FiX />
                                        </button>
                                    ) : null}
                                </div>
                            ))}
                        </div>
                    ))}
                </div>

                <div className="modalFooter">
                    <span className="igControlHint">Заполнено матчей: {filled}</span>
                    <button
                        className="igPrimaryBtn"
                        onClick={() => { onPick(current); onClose(); }}
                    >
                        Применить
                    </button>
                </div>
            </div>
        </div>
    );
}
